import { render } from "./PalliativeNetwork.vue?vue&type=template&id=7e2f30b6&scoped=true"
import script from "./PalliativeNetwork.vue?vue&type=script&lang=js"
export * from "./PalliativeNetwork.vue?vue&type=script&lang=js"

import "./PalliativeNetwork.vue?vue&type=style&index=0&id=7e2f30b6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e2f30b6"]])

export default __exports__